import { setCookie, getCookie } from '@convertdigital/gamma-cookie'
import { v4 as uuidv4 } from 'uuid'

/*
  Setting all cookies on load SearchSpring needs to have these set on load to work correctly.
*/
const SEARCHSPRING_KEY = '_isuid'

let currentUid = getCookie(SEARCHSPRING_KEY)

if (!currentUid) {
  const createUuid = () => {
    currentUid = uuidv4()

    return currentUid
  }

  setCookie(SEARCHSPRING_KEY, createUuid())
}

const setSSUserId = () => {
  const existingUserId = getCookie('ssUserId')

  if (!existingUserId) {
    setCookie('ssUserId', currentUid)
  }
}

const setSsSessionIdNamespace = () => {
  const existingSessionId = getCookie('ssSessionIdNamespace')

  if (!existingSessionId) {
    setCookie('ssSessionIdNamespace', uuidv4())
  }
}

setSsSessionIdNamespace()
setSSUserId()
